import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';
import ROUTE_PATHS from '../../../routes/paths';
import OnboardingStepsList from './OnboardingStepsList';
import OnboardingWrapper from './OnboardingWrapper';

const Welcome: React.FC<{ firstName: string }> = ({ firstName }) => {
  const navigate = useNavigate();

  const onBeginSetupClick = () => {
    navigate(ROUTE_PATHS.onboardingStep('company-details'));
  };

  const onExitClick = () => {
    navigate('/');
  };

  return (
    <OnboardingWrapper
      onSaveClick={{ onClick: onExitClick }}
      buttonLabel="Exit setup"
    >
      <Typography
        variant="h2"
        sx={{ whiteSpace: 'no-wrap' }}
      >{`Welcome to Airship, ${firstName}!`}</Typography>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Typography variant="body1">
          Begin setting up your account. This will take about 10 minutes to
          complete.
        </Typography>
        <OnboardingStepsList />
      </Grid>
      <Button fullWidth onClick={onBeginSetupClick}>
        Begin Setup
      </Button>
    </OnboardingWrapper>
  );
};

export default Welcome;
